@if (show()) {
    <div class="fixed top-0 left-0 w-full z-[9999]">
        <p-progressBar
            mode="indeterminate"
            [style]="{ height: '4px' }">
        </p-progressBar>
    </div>
}


